<!-- vue-chart.js requires that a component extend the chart component.
  you cannot add a template tag within the extended component, it will
   overwrite the chart component
-->
<template>
  <!-- <svg>
  </svg> -->
  <canvas :id="`donut-canvas-${$.uid}`" class="doughnut-canvas" width="128" height="128">
    <p>Add suitable fallback here.</p>
  </canvas>
</template>
<script>

export default {

  props: {
    percent: Boolean,
    // indexes implcitly align. label at index 0 corrisonds to data[0] and backgroundColor[0] and borderColor[0]
    chartData: {
      type: Object, //type of chartData
      datasets: [{
        labels: [String],  // string list
        data: [Number], //integer list
        backgroundColor: [String], // rgb(254,180,46)
        borderColor: [String], //rgb(254,180,46)
      }]
    }
  },
  data () {
    return {
      canvas: undefined,
      ctx: undefined,
      width: undefined,
      height: undefined,
    };
  },
  mounted () {
    this.update();
  },
  watch: {
    chartData: {
      handler (newVal, oldVal) {
        if (newVal.datasets[0])
          this.update();
      },
      deep: true,
    },
  },
  computed: {
    dataSum () {
      return this.chartData.data.reduce((x, y) => x + y);
    },

  },
  methods: {
    update () {
      const canvas = document.querySelector(`#donut-canvas-${this.$.uid}`);

      if (canvas == null) return;
      const dataset = this.chartData.datasets[0];
      if (!dataset) return;
      const dataSum = dataset.data.map(x => x < 0 ? 0 : x).reduce((x, y) => x + y);

      // percent of doughnut down to radians
      const percentMap = dataset.data.map(x => ((x < 0 ? 0 : x) / dataSum));
      const segmentMap = dataset.data.map((x, i) => this.degToRad((percentMap[i] * 360)));

      let ctx = canvas.getContext('2d');
      let width = canvas.width;
      // dia is the width of the canvas,
      const r = width / 2;
      // inner radius to make the doughnut hole
      const ir = r * .65;

      // base amount to rotate the chart, rotate up to 12 o'clock
      const rotate = this.degToRad(-90);
      // keep track of last arc end polar coordinate to start the next segment
      let cumulativeRad = 0;
      // this sweeps 2 arc along the percent of the segment is of the whole
      // one arc along the radius, clockwise start polar coordinate to end coordinate
      // and the inner radius counter-clockwise, end to start. these arcs are connected and drawn as a segment
      for (var i = 0; i < dataset.data.length; i++) {
        if (percentMap[i] == 0) {
          continue;
        }
        const radStart = rotate + cumulativeRad;
        const radEnd = rotate + segmentMap[i] + cumulativeRad;
        cumulativeRad += segmentMap[i];
        // draw path
        ctx.beginPath();
        ctx.fillStyle = dataset.backgroundColor[i];
        ctx.arc(r, r, r, radStart, radEnd, false);
        ctx.arc(r, r, ir, radEnd, radStart, true);
        ctx.fill();
      }
    },
    degToRad (degrees) {
      return (degrees) * Math.PI / 180;
    }
  },
};

</script>